import { render, staticRenderFns } from "./PostObjectsSro.vue?vue&type=template&id=d87e95ca"
import script from "./PostObjectsSro.vue?vue&type=script&lang=js"
export * from "./PostObjectsSro.vue?vue&type=script&lang=js"
import style0 from "./PostObjectsSro.vue?vue&type=style&index=0&id=d87e95ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports